import React, { useState } from 'react';

import { LifestylesListItemUploadedLifestyle } from './LifestylesListItemUploaded.types';

import { Tooltip } from '../../../../../../../helpers/tooltips/Tooltip';
import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';
import { DateHelper } from '../../../../../../../helpers/DateHelper';
import { Translate } from '../../../../../../../helpers/Translate';

import { words } from '../../../../../../../locales/keys';

interface LifestylesListItemUploadedProps {
  lifestyle: LifestylesListItemUploadedLifestyle;
}

function LifestylesListItemUploaded({
  lifestyle
}: LifestylesListItemUploadedProps) {
  const [referenceTooltipElement, setReferenceTooltipElement] =
    useState<HTMLSpanElement | null>(null);

  if (!lifestyle.maxFile?.createdAt) {
    return null;
  }

  return (
    <div
      className="text-gray-600 dark:text-gray-500 text-2xs truncate"
      ref={setReferenceTooltipElement}
    >
      <span>
        <Translate id={words.uploaded} />
        {': '}
        <DateHelper
          date={lifestyle.maxFile.createdAt}
          // customFormat={getCustomDateFormat(lifestyle.maxFile.createdAt)}
          customFormat="MMM dd, yyyy, h:mm a"
        />
      </span>

      <Tooltip
        withArrow
        placement={TooltipPlacement.TOP}
        referenceElement={referenceTooltipElement}
      >
        <DateHelper date={lifestyle.maxFile.createdAt} />
      </Tooltip>
    </div>
  );
}

export default LifestylesListItemUploaded;
